import { createFileRoute, Link } from '@tanstack/react-router';
import { OttoPilotCard } from './OttoPilotCard';

const components = [
  { name: 'Appointments', path: '/dev/Appointments' },
  { name: 'OttoPilot', path: '/dev/OttoPilot' },
  { name: 'Forms', path: '/dev/Forms' },
];

export const Route = createFileRoute('/dev/')({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <div style={{ padding: '2rem' }}>
      <h1>Component Playground</h1>
      <p>Select a component to preview:</p>
      <ul style={{ listStyle: 'none', padding: 0, marginTop: '1rem' }}>
        {components.map((component) => (
          <li key={component.path} style={{ marginBottom: '0.5rem' }}>
            <Link
              to={component.path}
              style={{
                color: '#0066cc',
                textDecoration: 'none',
                fontSize: '1.1rem',
              }}
            >
              {component.name}
            </Link>
            <OttoPilotCard />
          </li>
        ))}
      </ul>
    </div>
  );
}
